<template>
  <div>
    <highcharts
      :options="chartOptions"
      ref="lineCharts"
    ></highcharts>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";

import ApiDashboard from "../../apis/Dashboard"

export default {
  props: {
    partsdata: {
      type: Array
    }
  },

  components: {
    highcharts: Chart
  },

  data() {
    return {
      dataReport: [],
      categories: [],
      dataValues: [],
      chartOptions: {
        chart: {
          type: "spline",
          title: "Hassaan"
        },
        title: {
          text: 'Ventas del mes'
        },
        xAxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ]
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Total (S/)'
            }
        },
        tooltip: {
          crosshairs: true,
          shared: true
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: "#666666",
              lineWidth: 1
            }
          }
        },
        series: [
          {
            data: [10, 20, 18]
          }
        ]
      }
    };
  },
  methods: {
        getSalesMonth() {
            let currentDate = new Date()
            let month = currentDate.getMonth() + 1
            let year = currentDate.getFullYear()

            ApiDashboard.getSalesMonth(month, year).then((response) => {
                this.dataReport = response.data
                this.prepareData()
            }).catch( function(error){
                console.log('Ocurrió un error')
            });
        },
        prepareData() {
            this.categories = []
            this.dataValues = [] 
            this.dataReport.forEach((element, index) => {
                this.categories.push(element.date_order)
                this.dataValues.push(element.total)
            })
            let valueSeries = []
            valueSeries.push({
                name: 'Ventas',
                data: this.dataValues
            })
            this.chartOptions.xAxis.categories = this.categories
            this.chartOptions.series = valueSeries
        }
  },
  mounted() {
      this.getSalesMonth()
  }
};
</script>
